import yup from '../libs/yup'

export type Config = {
  _id?: string
  platformName: string
  logo?: string
  primaryColor: string
  password?: string
  secondaryColor: string
}

export const configSchema = yup.object().shape({
  platformName: yup.string().required().label('Nome da plataforma'),
  primaryColor: yup.string().required().label('Cor Primária'),
  secondaryColor: yup.string().required().label('Cor Secondária'),
})
